module.exports = __webpack_public_path__ + "/images/stokke-logo.c4f7687.svg";